import { defineStore } from "pinia";
/** loading*/
export const userStore = defineStore("store", {
  state: () => ({
    /**多國語言 */
    lang: null,
    loadingStatus: false,
  }),
  actions: {
    setLoading(payLoad) {
      this.loadingStatus = payLoad;
    },
    /**多國語言 */
    changeLang(payLoad) {
      localStorage.setItem("i18n", payLoad);
      this.lang = payLoad;
    },
  },
});
